// import { useUser } from '@folklore/auth';
import classNames from 'classnames';
import { useCallback, useRef } from 'react';

import usePage from '../../hooks/usePage';

import { useThemeClassName } from '../../contexts/ThemeContext';
import PageTitle from '../partials/PageTitle';
import Prizes from '../partials/Prizes';

import styles from '../../../styles/pages/account-prizes.module.scss';

function AccountPrizesPage() {
    const { page = null, refetch: reload } = usePage();
    const themeClassName = useThemeClassName(styles);

    const { title, prizes } = page || {};

    const prizesPositionRef = useRef(null);
    const onPrizeClaim = useCallback(() => {
        const { offsetTop } = prizesPositionRef.current;
        setTimeout(() => {
            window.scroll({
                top: offsetTop - 20,
                behavior: 'smooth',
            });
        }, 250);
    }, [reload]);

    return (
        <div className={classNames([styles.container, themeClassName])}>
            <PageTitle className={styles.pageTitle} title={title} />
            <div ref={prizesPositionRef} />
            <Prizes prizes={prizes} className={styles.prizes} onPrizeClaim={onPrizeClaim} />
        </div>
    );
}

export default AccountPrizesPage;
